module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/registry.npmmirror.com+vue-loader@11.3.4_8b9424a0e5a01d473cbe122e905f7d64/~/vue-loader/lib/template-compiler?{"id":"data-v-cf7ddabe"}!./~/.pnpm/registry.npmmirror.com+vue-loader@11.3.4_8b9424a0e5a01d473cbe122e905f7d64/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 12
// module chunks = 6